<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <b-card>
      <div class="d-flex align-items-center justify-content-between">
        <h3 class="mb-2">
          <i class="fad fa-ticket" />
          ตั้งค่าเทิร์นโอเวอร์ที่ได้รับค่าคอมมิชชั่น 1 %
        </h3>

        <div>
          <b-button
            variant="primary"
            class="mb-2"
            @click="saveCommissionSettings"
          >
            <i class="fad fa-cloud-download mr-50" />
            บันทึกข้อมูล
          </b-button>

        </div>
      </div>

      <b-row>
        <b-col md="3">
          <div class="card-list">
            <p style="font-size: 18px; font-weight: 500">
              ค่าคอมมิชชั่นแทงหวย
            </p>
            <b-form-group
              label="ขั้นต่ำ"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.min_turn_lotto"
                type="number"
                placeholder="ขั้นต่ำ"
              />
            </b-form-group>

            <b-form-group
              label="สูงสุด"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.max_turn_lotto"
                type="number"
                placeholder="สูงสุด"
              />
            </b-form-group>
          </div>
        </b-col>

        <b-col md="3">
          <div class="card-list">
            <p style="font-size: 18px; font-weight: 500">
              ค่าคอมมิชชั่นสล็อต
            </p>
            <b-form-group
              label="ขั้นต่ำ"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.min_turn_slot"
                type="number"
                placeholder="ขั้นต่ำ"
              />
            </b-form-group>

            <b-form-group
              label="สูงสุด"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.max_turn_slot"
                type="number"
                placeholder="สูงสุด"
              />
            </b-form-group>
          </div>
        </b-col>

        <b-col md="3">
          <div class="card-list">
            <p style="font-size: 18px; font-weight: 500">
              ค่าคอมมิชชั่นกีฬา
            </p>
            <b-form-group
              label="ขั้นต่ำ"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.min_turn_sport"
                type="number"
                placeholder="ขั้นต่ำ"
              />
            </b-form-group>

            <b-form-group
              label="สูงสุด"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.max_turn_sport"
                type="number"
                placeholder="สูงสุด"
              />
            </b-form-group>
          </div>
        </b-col>

        <b-col md="3">
          <div class="card-list">
            <p style="font-size: 18px; font-weight: 500">
              ค่าคอมมิชชั่นคาสิโน
            </p>
            <b-form-group
              label="ขั้นต่ำ"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.min_turn_casino"
                type="number"
                placeholder="ขั้นต่ำ"
              />
            </b-form-group>

            <b-form-group
              label="สูงสุด"
              label-for="customDelimiter"
            >
              <b-form-input
                id="floating-label2"
                v-model="agent.max_turn_casino"
                type="number"
                placeholder="สูงสุด"
              />
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
  },
  data() {
    return {
      agent: {
        min_turn_lotto: 0,
        max_turn_lotto: 0,
        min_turn_slot: 0,
        max_turn_slot: 0,
        min_turn_sport: 0,
        max_turn_sport: 0,
        min_turn_casino: 0,
        max_turn_casino: 0,
      },

      UserData: {
        agent_id: 18, // Example user data, replace with actual data
      },
    }
  },
  mounted() {
    // Fetch user data or any other initialization logic
    this.GetData()
  },
  methods: {
    fetchUserData() {
      this.UserData = {
        agent_id: 18, // Replace this with actual logic
      }
    },
    async GetData() {
      this.$http
        .get('/setting/commission/index')
        .then(response => {
          const { data } = response

          this.agent = {
            min_turn_lotto: data.mix_turnover_hj || 0,
            max_turn_lotto: data.max_turnover_hj || 0,
            min_turn_slot: data.mix_turnover_slot || 0,
            max_turn_slot: data.max_turnover_slot || 0,
            min_turn_casino: data.mix_turnover_casino || 0,
            max_turn_casino: data.max_turnover_casino || 0,
            min_turn_sport: data.mix_turnover_sport || 0,
            max_turn_sport: data.max_turnover_sport || 0,
          }
        })
        .catch(error => console.log(error))
    },
    async saveCommissionSettings() {
      this.$http
        .post('/setting/commission/update', {
          mix_turnover_slot: this.agent.min_turn_slot,
          max_turnover_slot: this.agent.max_turn_slot,
          mix_turnover_casino: this.agent.min_turn_casino,
          max_turnover_casino: this.agent.max_turn_casino,
          mix_turnover_sport: this.agent.min_turn_sport,
          max_turnover_sport: this.agent.max_turn_sport,
          mix_turnover_hj: this.agent.min_turn_lotto,
          max_turnover_hj: this.agent.max_turn_lotto,
        })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$bvToast.toast('บันทึกสำเร็จ', {
            title: 'Success',
            variant: 'success', // สีเขียวตาม theme
            solid: true,
          })
        })
        .catch(err => {
          console.error(err)
          this.$bvToast.toast('บันทึกล้มเหลว', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },

}
</script>

<style lang="scss" scoped>
.card-list {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  border: 4px solid #c1c1c147;
  &:hover {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
}
</style>
